<button
type="button"
class="button clear underline button--icon-on-top button--icon-on-top-inline padding-0 position-absolute"
[ngClass]="language === 'cy' ? 'wales' : ''"
(mousedown)="preventFocusOnElement($event)"
(click)="showToggleEmit()"
[attr.aria-label]="toggleShowPasswordAriaLabel | async"
>
<span *ngIf="!showPassword" aria-live="polite" class="show-for-sr">Your password is hidden</span>
<span *ngIf="showPassword" aria-live="polite" class="show-for-sr">Your password is shown</span>
  <div
    class="button__inner position-absolute"
    [ngClass]="showPassword ? 'hidden' : ''"
  >
    <svg
      class="icon icon--show-password"
      viewBox="0 0 24 24"
    >
      <use
        xlink:href="#icon-show-password"
        href="#icon-show-password"
      ></use>
    </svg>
    <div
      class="icon-text underline"
    >{{ showText | async }}</div>
  </div>
  <div
    class="button__inner position-absolute"
    [ngClass]="showPassword ? '' : 'hidden'"
  >
    <svg
      class="icon icon--hide-password"
      viewBox="0 0 24 24"
    >
      <use
        xlink:href="#icon-hide-password"
        href="#icon-hide-password"
      ></use>
    </svg>
    <div
      class="icon-text underline"
    >{{ hideText | async }}</div>
  </div>
</button>
